export const SEPA_COUNTRY_CODES = new Set([
  'AD', 'AL', 'AT', 'BE', 'BG', 'CH', 'CY', 'CZ', 'DE', 'DK', 'EE', 'ES',
  'FI', 'FR', 'GB', 'GI', 'GR', 'HR', 'HU', 'IE', 'IS', 'IT', 'LI', 'LT',
  'LU', 'LV', 'MC', 'MD', 'ME', 'MK', 'MT', 'NL', 'NO', 'PL', 'PT', 'RO',
  'RS', 'SE', 'SI', 'SK', 'SM', 'VA',
]);

export const normalizeIban = (value) => String(value || '').toUpperCase().replace(/[\s-]/g, '');

export const validateSepaIban = (value) => {
  const iban = normalizeIban(value);
  const country = iban.slice(0, 2);
  if (!iban) return { eligible: false, code: 'MISSING_IBAN', reason: 'IBAN mancante', iban, country };
  if (iban.length < 15 || iban.length > 34 || !/^[A-Z]{2}\d{2}[A-Z0-9]+$/.test(iban)) {
    return { eligible: false, code: 'INVALID_IBAN', reason: 'Formato IBAN non valido', iban, country };
  }
  if (country === 'IT' && iban.length !== 27) {
    return { eligible: false, code: 'INVALID_IBAN', reason: 'IBAN italiano: attesi 27 caratteri', iban, country };
  }
  const rearranged = `${iban.slice(4)}${iban.slice(0, 4)}`;
  const numeric = [...rearranged].map((char) => /[A-Z]/.test(char) ? String(char.charCodeAt(0) - 55) : char).join('');
  let remainder = 0;
  for (const digit of numeric) remainder = (remainder * 10 + Number(digit)) % 97;
  if (remainder !== 1) return { eligible: false, code: 'INVALID_IBAN', reason: 'Checksum IBAN non valido', iban, country };
  if (!SEPA_COUNTRY_CODES.has(country)) return { eligible: false, code: 'EXTRA_SEPA_COUNTRY', reason: `Bonifico extra-SEPA da gestire separatamente (${country})`, iban, country };
  return { eligible: true, code: 'SEPA_OK', reason: 'IBAN valido e Paese SEPA', iban, country };
};